import { value } from '@takeshape/util';
import { CURRENT_OPEN_API_TRANSFORM_VERSION } from "../constants.js";
import { updateAuthentication } from "../util/authentication.js";
import { hasEveryKey } from "../util/has.js";
import { endpointWithPath, getHealthCheck } from "../util/health.js";
export const specUrl = 'https://api.mailchimp.com/schema/3.0/Swagger.json?expand';
const serviceProvider = {
    name: 'mailchimp',
    title: 'Mailchimp',
    description: 'Mailchimp has the tools and resources you need to build a brand, sell online, and scale the business of your dreams.',
    categories: ['ecommerce', 'marketing'],
    links: [
        { title: 'Homepage', url: 'https://mailchimp.com/' },
        { title: 'Docs', url: '/docs/services/providers/mailchimp' }
    ],
    serviceType: 'openapi',
    introspectionType: 'openapi',
    createId: value('mailchimp'),
    getFormSchema: value({
        type: 'object',
        required: ['title', 'id', 'namespace', 'server', 'authentication'],
        properties: {
            title: {
                title: 'Name',
                type: 'string',
                default: 'Mailchimp'
            },
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9a-z_-]+',
                default: 'mailchimp'
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: 'Mailchimp'
            },
            server: {
                title: 'MailChimp Server',
                type: 'string'
            },
            authentication: {
                type: 'object',
                properties: {
                    password: {
                        title: 'API Key',
                        type: 'string'
                    }
                },
                required: ['password']
            }
        }
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'server', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'A human-readable title for this service.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'The human-readable unique identifier for this service. Only lowercase letters, numbers, hyphen, and underscore are allowed.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A namespace to use for any generated types or queries. For example, if you enter `Foo` your types will be named `Foo_Bar`.'
            },
            server: {
                widget: 'singleLineText',
                instructions: 'To find the value for your Mailchimp server, log into your Mailchimp account and look at the URL in your browser. You’ll see something like https://us19.admin.mailchimp.com/; the `us19` part is the server. Note that your specific value may be different.'
            },
            authentication: {
                properties: {
                    password: {
                        widget: 'sensitiveField',
                        instructions: 'To create an api key for Mailchimp, log in to your Mailchimp account then access Account → Extras → API Keys → Add API Key'
                    }
                },
                order: ['password']
            }
        }
    }),
    getConfig(formData) {
        const config = {
            id: formData.id,
            title: 'Mailchimp',
            provider: 'mailchimp',
            serviceType: 'openapi',
            authenticationType: 'basic',
            namespace: formData.namespace,
            options: {
                server: formData.server,
                endpoint: `https://${formData.server}.api.mailchimp.com/3.0`,
                spec: specUrl,
                transformVersion: CURRENT_OPEN_API_TRANSFORM_VERSION
            }
        };
        return updateAuthentication(config, formData, {
            type: 'basic',
            username: ''
        });
    },
    isCompleteConfig: hasEveryKey(['authentication', 'options.endpoint', 'options.spec']),
    getHealthCheck: getHealthCheck({
        checkName: 'ping',
        endpoint: endpointWithPath('/campaigns')
    })
};
export default serviceProvider;
